export default {
  "languageDisplayName": "English",
  "greeting": "Hello",
  "Profile": "Profile",
  "Interests": "Interests",
  "Recurring Payments": "Recurring Payments",
  "Payment Methods": "Payment Methods",
  "Transactions": "Transactions",
  "Passport": "Passport",
  "Wallet": "Wallet",
  "Subscriptions": "Subscriptions",
  "Projects": "Projects",
  "Campaigns": "Campaigns",
  "Volunteer": "Volunteer",
  "Events": "Events",
  "Settings": "Settings",
  "My": "My",
  "Groups": "Groups",
  "Awards": "Awards",
  "Change": "Change",
  "Image": "Image",
  "You have no": "You have no",
  "Now": "Now",
  "Booths": "Booths",
  "You don't have any listed": "You don't have any listed",
  "Add": "Add",
  "You Might Like:": "You Might Like: ",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Payment Method": "Payment Method",
  "Filter": "Filter",
  "Download": "Download",
  "Saved Cards": "Saved Cards",
  "Saved Debits": "Saved Debits",
  "Recommended": "Recommended",
  "Subscribe": "Subscribe",
  "Unsubscribe": "Unsubscribe",
  "Click to": "Click to",
  "Update": "Update",
  "Register": "Register",
  "Unregister": "Unregister",
  "Add More Interests": "Add More Interests",
  "Add More Skills": "Add More Skills",
  "Search": "Search",
  "Close": "Close",
  "Credit Card": "Credit Card",
  "card": "Credit Card",
  "Debit": "Debit",
  "debit": "Debit",
  "Cancel": "Cancel",
  "Account Name": "Account Name",
  "Institution Name": "Institution Name",
  "BSB Number": "BSB Number",
  "Account Number": "Account Number",
  "Cardholder Name": "Cardholder Name",
  "Card Number": "Card Number",
  "Expiration Date": "Expiration Date",
  "Cannot Be Empty": "Cannot Be Empty",
  "Not Valid": "Not Valid",
  "Save": "Save",
  "Cannot Be Empty or Contain Numbers": "Cannot Be Empty or Contain Numbers",
  "Login": "Login",
  "Awaiting Login": "Awaiting Login",
  "Awaiting Registration": "Awaiting Registration",
  "Please": "Please",
  "Logout": "Logout",
  "Offline": "Offline",
  "No Popups": "We have noticed you have blocked popups, please make sure you have them enabled for this site.",
  "Voting": "Voting",
  "Site Settings": "Site Settings",
  "My Settings": "My Settings",
  "Security Settings": "Security Settings",
  "2-Factor Authentication": "2-Factor Authentication",
  "Language": "Language",
  "Name": "Name",
  "Addresses": "Addresses",
  "Work": "Work",
  "Home": "Home",
  "Other": "Other",
  "Phone Numbers": "Phone Numbers",
  "Email Addresses": "Email Addresses",
  "First Name": "First Name",
  "Last Name": "Last Name",
  "Address Type": "Address Type",
  "Street Address 1": "Street Address 1",
  "Street Address 2": "Street Address 2",
  "City": "City",
  "State": "State",
  "Postcode": "Postcode",
  "Country": "Country",
  "Phone Number Type": "Phone Number Type",
  "Email Type": "Email Type",
  "Custom Type": "Custom Type",
  "Number": "Number",
  "Email": "Email",
  "Emails": "Emails",
  "Phone": "Phone",
  "Phones": "Phones",
  "Address": "Address",
  "Add Address": "Add Address",
  "Add Phone": "Add Phone",
  "Add Email": "Add Email",
  "Accommodation": "Accommodation",
  "Mobile": "Mobile",
  "View": "View",
  "No Groups": "You Have No Groups",
  "Recommended Groups": "Recommended Groups",
  "Roles": "Roles",
  "Admin": "Admin",
  "Photos": "Photos",
  "Join": "Join",
  "Leave": "Leave",
  "Joined": "Joined",
  "Member": "Member",
  "Members": "Members",
  "Are you sure?": "Are you sure?",
  "Yes": "Yes",
  "No": "No",
  "Fitness": "Fitness",
  "Help": "Help",
  "Gallery": "Gallery",
  "Support": "Support",
  "Unsupport": "Unsupport",
  "Skills": "Skills",
  "Communities": "Communities",
  "Click here to enter": "Click here to enter",
  "Rooms": "Rooms",
  "Boards": "Boards",
  "Cloud": "Cloud",
  "Future": "Future",
  "Churches": "Churches",
  "Password": "Password",
  "password": "password",
  "New Password": "New Password",
  "Old Password": "Old Password",
  "Confirm Password": "Confirm Password",
  "Subscribers": "Subscribers",
  "Browse": "Browse",
  "Past Events": "Past Events",
  "Future Events": "Future Events",
  "Create": "Create",
  "Edit": "Edit",
  "Issues": "Issues",
  "Organizer": "Organizer",
  "Next": "Next",
  "Back": "Back",
  "Confirm": "Confirm",
  "Select Payment Method": "Select Payment Method",
  "Please provide a payment method": "Please provide a payment method",
  "Select A Support Level": "Select A Support Level",
  "Your support will be sent from your selected payment method:": "Your support will be sent from your selected payment method:",
  "My Gallery": "My Gallery",
  "Local Artists": "Local Artists",
  "My Fitness": "My Fitness",
  "Next Due": "Next Due",
  "Frequency": "Frequency",
  "Status": "Status",
  "Link Your Fitbit": "Link Your Fitbit",
  "Link Your Strava": "Link Your Strava",
  "Active": "Active",
  "Cancelled": "Cancelled",
  "Tracker": "Tracker",
  "Mobile Number": "Mobile Number",
  "Day": "Day",
  "Month": "Month",
  "Year": "Year",
  "Date Of Birth": "Date Of Birth",
  "Sign Up": "Sign Up",
  "Check In": "Check In",
  "News": "News",
  "Deregister": "Deregister",
  "What's On": "What's On",
  "On Now": "On Now",
  "Coming Up": "Coming Up",
  "There are currently no upcoming events": "There are currently no upcoming events",
  "Test": "Test",
  "Next Up": "Next Up",
  "Near Me": "Near Me",
  "Goals": "Goals",
  "Connect": "Connect",
  "Select An Option": "Select An Option",
  "Mentors": "Mentors",
  "Employment": "Employment",
  "Log In": "Log In",
  "Log Out": "Log Out",
  "Please log in or sign up to continue.": "Please log in or sign up to continue.",
  "Add your group": "Add your group",
  "Preferred": "Preferred",
  "Read More": "Read More",
  "Description": "Description",
  "Submit": "Submit",
  "Subject": "Subject",
  "Message": "Message",
  "Send Me A Copy": "Send Me A Copy",
  "Contacts": "Contacts",
  "Followers": "Followers",
  "Follow": "Follow",
  "Following": "Following",
  "Contact Number": "Contact Number",
  "Any unsaved information may be lost": "Any unsaved information may be lost",
  "Add Location": "Add Location",
  "Edit Location": "Edit Location",
  "Last Logged In": "Last Logged In",
  "Your Connections": "Your Connections",
  "There are no connections currently linked to your account": "There are no connections currently linked to your account",
  "Connection Type": "Connection Type",
  "Remove Connection": "Remove Connection",
  "Connect To: ": "Connect To : ",
  "Timezone": "Timezone",
  "forgotPassword": "I don't know my password",
  "createNewAccount": "Create new account",
  "logInWith": "Log in with",
  "orEnterYour": "or enter your",
  "usernameOrEmail": "username or email",
  "passwordRequired": "password is required",
  "enterPasswordFor": "enter password for",
  "authenticationFailed": "authentication failed",
  "signIn": "sign in",
  "iHaveAnAccount": "I have an account",
  "termsAndPrivacy": "terms & privacy",
  "securedBy": "secured by",
  "Delete": "Delete",
  "Please Wait": "Please Wait",
  "loadingDiscussions": "Loading Your Messages!",
  "No Discussions": "No Discussions!",
  "joinDiscussion": "Join a discussion for it to display here!",
  "Discussion": "Discussion",
  "Log in with :": "Log in with:",
  "Powered By:": "Powered By:",
  "Please accept the latest": "Please accept the latest",
  "Terms": "Terms",
  "terms": "terms",
  "Privacy Policy": "Privacy Policy",
  "privacy policy": "privacy policy",
  "willRecieveFollowingInfo": "will receive the following info:",
  "Email Address": "Email Address",
  "and": "and",
  "We Use Cookies": "We Use Cookies",
  "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Cookies help us handle many processes our platform requires, please accept or review our available settings",
  "ACCEPT ALL": "ACCEPT ALL",
  "REJECT ALL": "REJECT ALL",
  "ACCEPT CURRENT SELECTION": "ACCEPT CURRENT SELECTION",
  "SETTINGS": "SETTINGS",
  "Manage cookie preferences": "Manage cookie preferences",
  "Close modal": "Close modal",
  "Strictly Necessary cookies": "Strictly Necessary cookies",
  "These cookies are essential for the proper functioning of the website and cannot be disabled.": "These cookies are essential for the proper functioning of the website and cannot be disabled.",
  "Performance and Analytics": "Performance and Analytics",
  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.": "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.",
  "ACCEPT REQUIRED": "ACCEPT REQUIRED",
  "Terms and Privacy Policy Links": "Terms and Privacy Policy Links",
  "Services": "Services",
  "Profile Pages": "Profile Pages",
  "Success": "Success",
  "Your disconnection request has successfully been processed": "Your disconnection request has successfully been processed",
  "Disconnecting will cause a new authorization prompt on next login to any related services": "Disconnecting will cause a new authorization prompt on next login to any related services",
  "Legal": "Legal",
  "Available Services": "Available Services",
  "Link": "Link",
  "Disconnect": "Disconnect",
  "Agreed": "Agreed"
};